import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AvatarComponent } from '../avatar/avatar';

export interface AvatarGroupMember {
  name: string;
  src?: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-avatar-group',
  imports: [AvatarComponent],
  styleUrl: './avatar-group.scss',
  templateUrl: './avatar-group.html',
})
export class AvatarGroupComponent {
  /** Membres à afficher, dans l'ordre d'empilement. */
  readonly members = input<AvatarGroupMember[]>([]);

  /** Nombre maximal d'avatars affichés avant le compteur « +N ». */
  readonly max = input(5);

  protected readonly visible = computed(() => this.members().slice(0, this.max()));
  protected readonly hiddenCount = computed(() =>
    Math.max(0, this.members().length - this.max()),
  );

  protected readonly membersLabel = computed(() =>
    this.members()
      .map((member) => member.name)
      .join(', '),
  );
}
